import { Engine1Proxy, RestApiProxy } from 'com-gyf-webcore-servicehub';

let NovedadesManager = function () {
    let _now;

    /**
     * 
     * @param {any} novedades
     * @param {any} viewCallback
     */
    function _guardarNovedades(novedades, viewCallback) {
        _now = new Date();
        
        novedades.forEach(function (novedad, index) {
            let localValues = mapearNovedad(novedad);
            let isQuery = false;//ver
            let deleteInstance = false;//ver
            Engine1Proxy.AddEventSourcingDataRequest(localValues, 'EVENTSOURCING_TRANSACTION_NOVEDAD', 'Tarjetas', 'ADMINEMPCUETAR', index, isQuery, null, deleteInstance, novedad.Id);
        });
        
        Engine1Proxy.Execute(viewCallback, null, null, "ADMINEMPCUETAR");
    }

    //TODO: Ver los comentarios con tareas futuras de front-end (Tarea #AD17-768)
    /**
     * 
     * @param {any} novedad
     */
    function mapearNovedad(novedad) {
        
        let values = {
            "NOVEDAD_TIPO_ID": novedad.TipoEntidad,
            "NOVEDAD_CAMPO_ID": novedad.NovedadCampoId, //Id en tabla NOVEDAD_CAMPO que se relaciona con el código del campo modificado (NOVEDAD_CAMPO.CODIGO). Ver en tarea AD17-554 la relación de cada atributo de la cuenta con el código de novedad correspondiente.
            "NOVEDAD_CAMPO_CODIGO": novedad.Codigo, //Código asociado al Id indicado en el campo anterior.
            "VALOR_ANTERIOR": novedad.ValorAnterior, //Valor original del atributo (el que aún está vigente en la tabla correspondiente). Registrar el ID, si el atributo se maneja a través de un código.
            "VALOR_NOVEDAD": novedad.ValorNovedad, //Nuevo valor indicado para el atributo. Registrar el ID, si el atributo se maneja a través de un código.
            "USUARIO_LOGIN_MODIFICACION": novedad.UsuarioLogin,
            "USUARIO_LOGIN_CONFIRMACION": novedad.UsuarioLoginConf ? novedad.UsuarioLoginConf : null ,
            "FECHA_HORA_CONFIRMACION": novedad.UsuarioLoginConf ? _now : null ,
            "FECHA_HORA_MODIFICACION": _now,
            "TERMINAL_MODIFICACION": null,
            "TERMINAL_CONFIRMACION": null,
            "NOVEDAD_ESTADO_ID": novedad.EstadoId, //NovedadEstadoId. 1 (Completada) o 2 (Confirmada), según parámetro SINOCONFIRMACIONMODIFCTA de la configuración general (Tarea Redmine #24397).
            "FECHA_INTERFAZ_ADMINISTRADORA": novedad.FechaInterfazAdministradora,
            "FECHA_RESPUESTA_ADMINISTRADORA": null,
            "SOLICITUD_ID": null,
            "ORIGEN_ADM": 0,
            "CLIENTE_ID": novedad.ClienteId ? novedad.ClienteId : null 
        };

        switch (novedad.tipoEntidad) {
            case 0:
                values.EMPRESA_VISA_ID = novedad.EmpresaVisaId;
                break;
            case 1:
                values.CUENTA_TARJETA_ID = novedad.CuentaTarjetaId;
                break;
            case 2:
                values.TARJETA_CREDITO_ID = novedad.TarjetaCreditoId;
                //- Se necesita el id de la cuenta para obtener las novedades de las tarjetas.
                values.CUENTA_TARJETA_ID = novedad.CuentaTarjetaId;
                break;
        }

        //UsuarioLoginConfirmacion. NULL, si la novedad se registra en estado "Completada", o ídem UsuarioLoginModificacion, si se registra en estado "Confirmada" (ver consideración atributo NovedadEstadoId).
        //FechaHoraConfirmacion.NULL, si la novedad se registra en estado "Completada", o ídem FechaHoraModificacion, si se registra en estado "Confirmada" (ver consideración atributo NovedadEstadoId).
        switch (novedad.EstadoSolicitud) {
            case "Completada":
                values.USUARIO_LOGIN_CONFIRMACION = values.FECHA_HORA_CONFIRMACION = null;
                break;
            case "Confirmada":
                values.USUARIO_LOGIN_CONFIRMACION = novedad.UsuarioLogin;
                values.FECHA_HORA_CONFIRMACION = _now;
                break;
        }

        return values;
    }

    return {
        GuardarNovedades: function (novedades, viewCallback) {
            return _guardarNovedades(novedades, viewCallback);
        }
    }
};

let novedadesManager = new NovedadesManager();
export default novedadesManager;